import React, {useEffect, useState} from "react";
import {Button, Image, mergeClasses, Spinner} from "@fluentui/react-components";
import DefaultImg from '../../../../assets/iconImg/defaultImg.png'
import rankIcon from '../../../../assets/icons/ic_rank.svg';
import keywordIcon from '../../../../assets/icons/ic_Keyword.svg';
import linkIcon from '../../../../assets/icons/ic_link.svg';
import copyIcon from '../../../../assets/icons/ic_copy.svg';
import {useStyles} from "../../../../styles/mission/ver1";
import {ShoppingPathJointEventIO} from "../../../../io/content/shoppingPathJointEventIO";
import {EventType} from "../../../../constant/EventType";
import AlertDialog from "../common/AlertDialog";
import TitleBar from "../common/TitleBar";
import {isVisible} from "../../../../utils/bitmask";
import {Column, Row} from "../../../../ui/mission/common/Layout";
import {pinkTheme} from "../../../../styles/mission/theme";
import {formatRank} from "../../../../utils/rank";
import OtherMissionBtn from "../common/OtherMissionBtn";
import {copyToClipboard, onHandleUrlBtn} from "../../../../utils/nshopQuiz";
import AnswerInput from "../common/AnswerInput";
import {ShoppingPresentationValueObject} from "../../../../model/vo/content/ShoppingPresentationValueObject";
import {formatNumber} from "../../../../utils/price";
import {ErrorPage} from "../../../../ui/mission/common/ErrorPage";
import {formatProductName, formatStoreName} from "../../../../utils/store";
import {PathTypeString} from "../../../../constant/pathType";
import {setPathType} from "../../../../utils/pathType";
import StyledPathText from "../../common/StyledPathText";

export default function Mission(
    {mediaCode,mediaId,data,isLoading,primaryColor,otherMissionBtnClick}:
    {
        mediaCode:string,
        mediaId:string,
        data:ShoppingPresentationValueObject | null,
        isLoading:boolean,
        primaryColor:string,
        otherMissionBtnClick:()=>void
    }) {

    const styles = useStyles();

    const [isEnd, setIsEnd] = useState(false)
    const [img, setImg] = useState<string | null>(null)
    const [isDialogOpen, setIsDialogOpen] = useState(false)
    const [dialogTitle, setDialogTitle] = useState<string>('')
    const [dialogMsg, setDialogMsg] = useState<string>('')
    const [isCopied, setIsCopied] = useState(false)

    const openDialog = (title: string, content: string, src: string | null) => {
        try {
            setDialogTitle(title)
            setDialogMsg(content)
            setImg(src)
        } finally {
            setIsDialogOpen(true)
        }
    }

    const closeDialog = () => setIsDialogOpen(false)

    useEffect(() => {
        const handleCopy = (e: ClipboardEvent) => {
            e.preventDefault()
            openDialog(
                '경고',
                '복사가 금지되어 있습니다.\n하단의 버튼을 이용해서 미션을 진행해주세요!',
                null
            )
        }

        document.addEventListener('copy', handleCopy)

        return () => {
            document.removeEventListener('copy', handleCopy)
        }
    }, [])

    if (isLoading)
        return <Spinner/>

    return (
        (!data || !data.visibility) ?
            <ErrorPage/>
            :
            <>
                <AlertDialog
                    title={dialogTitle}
                    description={dialogMsg}
                    isOpen={isDialogOpen}
                    onClose={closeDialog}
                    src={img}
                    primaryColor={primaryColor}
                />

                <main className={styles.main} >
                    <TitleBar title={"TokTokQuiz"} campaignTitle={data.title || ''} primaryColor={primaryColor} />
                    <div style={{margin: '20px'}}>
                        <div style={{height: '30px'}}/>

                        <Column justifyContent={'center'} alignItems={'center'} marginBottom={'8px'}>
                            <div className={styles.guideMessage} style={{color:primaryColor}}>
                                {PathTypeString[setPathType(data.pathType)].split('\n').map((v) => <StyledPathText str={v} />)}
                            </div>
                        </Column>

                        <Column gap={'12px'}>
                            {/* 상품정보 카드 */}
                            <div className={styles.productCard} style={{border:'none'}}>
                                {isVisible(data.visibility, 4) && (
                                    <div className={styles.productImg} style={{flex:1}}>
                                        <Image
                                            alt="상품이미지"
                                            src={data.productImageUrl || DefaultImg}
                                            width={100}
                                            height={100}
                                            shape="rounded"
                                        />
                                    </div>
                                )}

                                <div className={styles.productInfo} style={{fontFamily: 'NanumSquare', flex:2, gap:'2px', justifyContent:'center'}}>
                                    {isVisible(data.visibility, 1) && (
                                        <div
                                            className={styles.description} style={{
                                            color: pinkTheme.productName,
                                            fontSize: '16px',
                                            fontWeight: 'medium',
                                            flex:0
                                        }}>
                                            {formatProductName(data.productName || '', data.storeName || '')}
                                        </div>
                                    )}

                                    {isVisible(data.visibility, 2) && (
                                        <div
                                            className={styles.description} style={{
                                            fontSize: '14px',
                                            fontFamily: 'NanumSquareExtraBold',
                                        }}>
                                            {formatNumber(data.productPrice|| 0) + '원'}
                                        </div>
                                    )}
                                    {isVisible(data.visibility, 0) && (
                                        <div
                                            className={styles.description} style={{
                                            color: pinkTheme.storeName,
                                            fontSize: '12px',
                                            fontWeight: 'medium',
                                            flex:0
                                        }}>
                                            {formatStoreName(data.storeName || '')}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* 단품상품 정보 */}
                            {
                                <div className={styles.productCard} style={{border: 'none', display: 'flex'}}>
                                    {isVisible(data.visibility, 5) && (
                                        <Column gap={'8px'} flex={'1'} justifyContent={'center'} alignItems={'center'} marginLeft={'16px'} marginRight={'8px'}>
                                            <Row className={mergeClasses(styles.primaryBtn,styles.roundedBtn)}
                                                 style={{
                                                     backgroundColor:primaryColor,
                                                     border:`2px solid ${primaryColor}`,
                                                     fontSize: 'large',
                                                     display:'flex',
                                                     gap:'6px'
                                                 }}>
                                                <Image alt={"순위 아이콘"} src={rankIcon} width={20} height={20}/>
                                                    현재 순위
                                            </Row>
                                            <Row justifyContent={'center'}  className={styles.description}>
                                                 {formatRank(data.rank || 0)+' 위'}
                                            </Row>
                                        </Column>
                                    )}
                                    {isVisible(data.visibility, 3) && (
                                        <Column gap={'8px'} flex={'1'} justifyContent={'center'} alignItems={'center'} marginRight={'16px'} marginLeft={'8px'} >
                                            <Row className={mergeClasses(styles.primaryBtn,styles.roundedBtn)}
                                                          style={{
                                                              backgroundColor:primaryColor,
                                                              border:`2px solid ${primaryColor}`,
                                                              fontSize: 'large',
                                                              display:'flex',
                                                              gap:'6px'
                                                        }}>
                                                        <Image alt={"키워드 아이콘"} src={keywordIcon} width={20} height={20}/>
                                                        키워드
                                            </Row>
                                            <Row>
                                                <div className={styles.description}
                                                     style={{justifyContent:'center'}}>
                                                    {data.mainKeyword}
                                                </div>
                                            </Row>
                                        </Column>
                                    )}
                                </div>
                            }

                            <OtherMissionBtn onClick={otherMissionBtnClick}/>
                            <Row gap={'8px'}>
                                {/* Buttons */}
                                {isVisible(data.visibility, 6) && (
                                    <Button
                                        icon={<Image alt={"복사 아이콘"} src={copyIcon} width={15} height={15}/>}
                                        className={mergeClasses(styles.roundedBtn, styles.outlinedBtn)}
                                        style={{flex:1}}
                                        size="large"
                                        onClick={() => {
                                            copyToClipboard(
                                                data.mainKeyword || '',
                                                () => {
                                                    openDialog("오류", "복사에 실패했습니다.",null);
                                                    setTimeout(() => {
                                                        closeDialog();
                                                    }, 10000);
                                                    return;
                                                },
                                                () => {
                                                    setIsCopied(true)
                                                    if (data.shoppingPathJointId && data.userId) {
                                                        ShoppingPathJointEventIO.post({
                                                            shoppingPathJointId: data.shoppingPathJointId,
                                                            userId: data.userId,
                                                            misc: mediaId,
                                                            eventType: EventType.ClipboardClick
                                                        }).then(
                                                            v => console.log(v)
                                                        ).catch(e => console.error(e))
                                                    }
                                                },
                                                () => {
                                                }
                                            );
                                        }}
                                    >
                                        검색어 복사하기
                                    </Button>
                                )}

                                {isVisible(data.visibility, 7) && (
                                    <Button
                                        icon={<Image alt={"링크 아이콘"} src={linkIcon} width={15} height={15}/>}
                                        className={mergeClasses(styles.roundedBtn, styles.primaryBtn)}
                                        style={{
                                            backgroundColor: primaryColor,
                                            border: `1.5px solid ${primaryColor}`,
                                            flex: 1,
                                            color:'white'
                                        }}
                                        onClick={() =>
                                            onHandleUrlBtn(
                                                data.format || '',
                                                isVisible(data.visibility, 6),
                                                data.browser || '',
                                                isCopied,
                                                () => {
                                                    openDialog('경고', '복사가 필요한 미션입니다!',null);
                                                    setTimeout(() => {
                                                        closeDialog();
                                                    }, 10000);
                                                    return;
                                                },
                                                () => {
                                                    if (data.shoppingPathJointId && data.userId) {
                                                        ShoppingPathJointEventIO.post({
                                                            shoppingPathJointId: data.shoppingPathJointId,
                                                            userId: data.userId,
                                                            misc:mediaId,
                                                            eventType: EventType.MissionClick
                                                        }).then(
                                                            v => {
                                                                console.log(v)
                                                            }
                                                        ).catch(e => console.error(e))
                                                    }
                                                }
                                            )
                                        }
                                    >
                                        미션하러 가기
                                    </Button>
                                )}
                            </Row>
                        </Column>
                        <div style={{height: '150px'}}/>
                    </div>
                </main>

                {
                    data.shoppingPathJointId && data.userId && (
                        <div className={styles.fixedBottom} style={{padding: '0px'}}>
                            <AnswerInput
                                mediaCode={mediaCode || ''}
                                shoppingPathJointId={data.shoppingPathJointId}
                                userId={data.userId}
                                mediaId={mediaId || ''}
                                setIsEnd={setIsEnd}
                                data={data}
                                primaryColor={primaryColor}
                            />
                        </div>
                    )
                }

            </>
    );
}